// Shared schema for the EGM transparency index (used by public card and admin form)
export const TRASPARENZA_AREE = [
  {
    key: "sito_investor_relations",
    label: "Sito Investor Relations",
    max: 20,
    criteri: [
      { key: "sezione_ir_dedicata", label: "Sezione IR dedicata", max: 5 },
      { key: "bilanci_scaricabili", label: "Bilanci scaricabili", max: 5 },
      { key: "presentazioni_investitori", label: "Presentazioni investitori", max: 5 },
      { key: "sito_in_inglese", label: "Sito in inglese", max: 5 },
    ],
  },
  {
    key: "assemblee_azionisti",
    label: "Assemblee azionisti",
    max: 25,
    criteri: [
      { key: "convocazione_nei_tempi", label: "Convocazione nei tempi", max: 5 },
      { key: "domande_pre_assemblea", label: "Domande pre-assemblea", max: 10 },
      { key: "risposte_pubblicate", label: "Risposte pubblicate", max: 5 },
      { key: "verbale_pubblicato_30gg", label: "Verbale pubblicato entro 30gg", max: 5 },
    ],
  },
  {
    key: "comunicazioni_mercato",
    label: "Comunicazioni al mercato",
    max: 20,
    criteri: [
      { key: "comunicati_trimestrali", label: "Comunicati trimestrali", max: 5 },
      { key: "commento_management", label: "Commento del management", max: 5 },
      { key: "investor_presentation", label: "Investor presentation", max: 5 },
      { key: "contatto_ir_nominativo", label: "Contatto IR nominativo", max: 5 },
    ],
  },
  {
    key: "dialogo_azionisti",
    label: "Dialogo con azionisti",
    max: 20,
    criteri: [
      { key: "email_ir_risposta_5gg", label: "Email IR: risposta entro 5gg", max: 10 },
      { key: "roadshow_investor_day", label: "Roadshow / Investor day", max: 5 },
      { key: "presenza_piattaforme_ir", label: "Presenza su piattaforme IR", max: 5 },
    ],
  },
  {
    key: "qualita_informazione",
    label: "Qualità dell'informazione",
    max: 15,
    criteri: [
      { key: "kpi_operativi_pubblicati", label: "KPI operativi pubblicati", max: 5 },
      { key: "guidance_futura", label: "Guidance futura", max: 5 },
      { key: "analisi_rischi_dettagliata", label: "Analisi rischi dettagliata", max: 5 },
    ],
  },
];

export const TRASPARENZA_MAX = 100;

export const fasciaTrasparenza = (score) => {
  if (score >= 80) return { label: "Eccellente", stars: "⭐⭐⭐⭐", color: "#2e7d32" };
  if (score >= 60) return { label: "Buono", stars: "⭐⭐⭐", color: "#57a639" };
  if (score >= 40) return { label: "Sufficiente", stars: "⭐", color: "#f5a623" };
  return { label: "Insufficiente", stars: "", color: "#d32f2f" };
};

export const criterioLabel = (areaKey, critKey) => {
  const area = TRASPARENZA_AREE.find((a) => a.key === areaKey);
  const c = area?.criteri.find((x) => x.key === critKey);
  return c?.label || critKey;
};
